import { useEffect, useState } from 'react';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { Button, DialogTitle, Stack, TextField as MuiTextField, Typography, styled } from '@mui/material';

import { mutateGroupAtom } from '@/interfaces/site';

interface AddGroupDialogProps {
  onClose: () => void;
}

const TextField = styled(MuiTextField)`
  background-color: #F1F1F1;
`;

export default function AddGroupDialog({ onClose }: AddGroupDialogProps) {
  const [groupName, setGroupName] = useState('');
  const { mutate, isPending, data } = useAtomValue(mutateGroupAtom);
  const { t } = useTranslation();

  useEffect(() => {
    if (data === undefined) return;
    if (data) {
      onClose();
    } else {
      window.alert(t('Settings.message.cannotAddGroup'));
    }
  }, [data, onClose, t]);

  async function onOkClick() {
    mutate(groupName);
  }

  return (
    <Stack gap={2} sx={{ minWidth: 480, p: 3 }}>
      <DialogTitle sx={{ px: 0 }}>{t('Settings.label.addGroup')}</DialogTitle>
      <Typography>{t('Settings.label.groupName')}</Typography>
      <TextField value={groupName} onChange={(e) => setGroupName(e.target.value)} />
      <Stack direction="row" justifyContent="center" gap={3}>
        <Button variant="contained" onClick={onClose} sx={{ bgcolor: '#CCC', color: 'black' }}>
          {t('Common.label.cancel')}
        </Button>
        <Button
          variant="contained"
          disabled={groupName.trim().length === 0 || isPending}
          onClick={onOkClick}
          sx={{ bgcolor: 'info.main' }}
        >
          {t('Common.label.ok')}
        </Button>
      </Stack>
    </Stack>
  );
}
